function mergeRecursive (model, source) {
  let target = { ...model }

  Object.keys(target).forEach(key => {
    if (source.hasOwnProperty(key)) {

      if (typeof target[key] === 'object' && target[key] !== null) {
        target[key] = mergeRecursive(target[key], source[key])
      } else {
        target[key] = source[key]
      }
    }
  })

  return target
}

export default mergeRecursive
